import React, { useEffect, useRef, useState } from "react";
import { userRequest } from "../../api/requestMethods";

export default function MerchantPaymentReport({ orderId }) {
  const [open, setOpen] = useState(false);
  const [claims, setClaims] = useState([]);
  const [provider, setProvider] = useState("MTN");
  const [transactionId, setTransactionId] = useState("");
  const [loading, setLoading] = useState(false);
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const mounted = useRef(true);
  const submitting = useRef(false);
  const path = `/weborders/${orderId}/payment/merchant-claims`;
  useEffect(() => { mounted.current = true; return () => { mounted.current = false; }; }, []);
  useEffect(() => {
    if (!open) return;
    let cancelled = false;
    setLoading(true); setError("");
    userRequest.get(path).then(({ data }) => { if (!cancelled) setClaims(data.data.claims); })
      .catch(err => { if (!cancelled) setError(err.response?.data?.message || "Could not load transaction reports."); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [open, path]);
  const submit = async event => {
    event.preventDefault();
    if (submitting.current || loading) return;
    submitting.current = true; setBusy(true); setError(""); setMessage("");
    try {
      const { data } = await userRequest.post(path, { provider, transactionId: transactionId.trim() });
      if (mounted.current) {
        setClaims(previous => [data.data.claim, ...previous.filter(c => c.id !== data.data.claim.id)]);
        setMessage(data.data.message); setTransactionId("");
      }
    } catch (err) { if (mounted.current) setError(err.response?.data?.message || "Could not send the report. Refresh before submitting again."); }
    finally { submitting.current = false; if (mounted.current) setBusy(false); }
  };
  return <details onToggle={event => setOpen(event.currentTarget.open)} style={{ background: "white", border: "1px solid #d8d8d5", borderRadius: 10, padding: 16, marginBottom: 16 }}>
    <summary>Report a merchant payment already sent</summary>
    {open && <>
      <p>Only report a payment you already sent to a merchant account. Do not send another payment while your earlier payment is unresolved.</p>
      <p>Transaction IDs remain unverified. Submitting one does not confirm payment or change your order’s payment status. Never enter a wallet PIN or OTP.</p>
      {error && <p role="alert">{error}</p>}{message && <p role="status">{message}</p>}
      {loading ? <p>Loading reports…</p> : <>
        {claims.length > 0 && <ul>{claims.map(claim => <li key={claim.id} style={{ overflowWrap: "anywhere" }}>{claim.provider}: {claim.transactionId} · Unverified</li>)}</ul>}
        <form onSubmit={submit}>
          <label htmlFor="merchant-report-network">Payment network</label>
          <select id="merchant-report-network" disabled={busy} value={provider} onChange={e => setProvider(e.target.value)} style={{ display: "block", padding: 10, marginBottom: 12 }}>
            <option value="MTN">MTN</option><option value="AIRTEL">Airtel</option>
          </select>
          <label htmlFor="merchant-report-id">Transaction ID</label>
          <input id="merchant-report-id" value={transactionId} disabled={busy} maxLength={80} autoComplete="off" onChange={e => setTransactionId(e.target.value)} style={{ display: "block", width: "100%", padding: 10, marginBottom: 12 }} />
          <button type="submit" disabled={busy || !/^[A-Za-z0-9][A-Za-z0-9._:/-]{3,79}$/.test(transactionId.trim())} style={{ padding: 12 }}>{busy ? "Sending…" : "Send unverified transaction ID"}</button>
        </form>
      </>}
    </>}
  </details>;
}
